// extracted by mini-css-extract-plugin
export default {"button":"BaseCookie-ECyYM__button","link":"BaseCookie-U4Cvn__link"};